[
  {
    "id": "chapter:4a",
    "q": "The traditional mirror setting:",
    "answer": {
      "text": "May be more appropriate when towing or backing in tight areas",
      "section": 4,
      "topic": "Traditional Mirror Settings",
      "page": 26
    },
    "otherChoices": [
      "Adds 12 to 16 degrees additional viewing area to each side of the vehicle",
      "Can be adjusted by leaning your head to the left/right until it touches the driver side window, and the rear fender is just visible"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:4b",
    "q": "Safety belts:",
    "answer": {
      "text": "Must be worn always",
      "section": 4,
      "topic": "Using Safety Belts",
      "page": 27
    },
    "otherChoices": [
      "Do not need to be worn if your vehicle is equipped with air bags",
      "Only need to be worn when driving on long trips"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:4c",
    "q": "Where should you place a child under 12 years old in a vehicle equipped with air bags?",
    "answer": {
      "text": "The back seat",
      "section": 4,
      "topic": "Child Passenger Safety Laws",
      "page": 28
    },
    "otherChoices": ["The front seat", "In either the front or back seat"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "authored:s4-booster-seat-age",
    "q": "Children between the ages of 4 and 8 who are no more than 4 feet 9 inches tall should ride in the back seat in:",
    "answer": {
      "text": "A properly installed booster seat",
      "section": 4,
      "topic": "Child Passenger Safety Laws",
      "page": 28
    },
    "otherChoices": [
      "A properly installed, forward-facing child safety seat",
      "An adult safety belt without a booster"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s4-head-restraints",
    "q": "Head restraints are designed to prevent:",
    "answer": {
      "text": "Whiplash if you are hit from behind",
      "section": 4,
      "topic": "Adjusting Seat and Mirrors",
      "page": 26
    },
    "otherChoices": ["Being thrown from the vehicle", "Injury from a deploying air bag"],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s4-shoulder-harness",
    "q": "A shoulder harness is worn:",
    "answer": {
      "text": "Across the shoulder and chest with minimal if any slack",
      "section": 4,
      "topic": "Using Safety Belts",
      "page": 27
    },
    "otherChoices": ["Under the arm", "Behind the back"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s4-front-air-bag-deployment",
    "q": "Front air bags are designed to deploy in:",
    "answer": {
      "text": "Frontal and near-frontal collisions",
      "section": 4,
      "topic": "Air Bags",
      "page": 28
    },
    "otherChoices": ["Side impact, rear impact, or rollover crashes", "A secondary collision"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s4-lap-belt-position",
    "q": "The lap belt should be adjusted so that it is:",
    "answer": {
      "text": "Snug and lies low across your hips",
      "section": 4,
      "topic": "Using Safety Belts",
      "page": 27
    },
    "otherChoices": [
      "Worn across the shoulder and chest with minimal slack",
      "Loose enough to slide out of easily in a collision"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s4-air-bag-hand-placement",
    "q": "To help prevent injury when an air bag inflates, you should place your hands:",
    "answer": {
      "text": "On the outside of the steering wheel, never across the steering wheel where the air bag deploys",
      "section": 4,
      "topic": "Air Bags",
      "page": 28
    },
    "otherChoices": ["At 2 and 10 o'clock", "Gripping the wheel from the inside of the rim"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 3,
    "updatedAt": "2026-08-03",
    "status": "verified"
  }
]
